import { Logo } from "../Logo"
import { SideDrawerProps } from "./SideDrawer.interfaces"

export const SideDrawer = ({ children, logo, onClose }: SideDrawerProps) => {
  return(
    <div className="fixed top-0 left-0 w-full h-screen z-50">
      <div 
        className="bg-black-opacity-50 absolute left-0 top-0 w-full h-full" 
        onClick={onClose} 
      />
      <div className="bg-white relative flex flex-col text-black p-4 h-full">
        <div className="flex items-center">
          {logo && (
            <Logo {...logo} />
          )}
          <button 
            className="flex items-center justify-center ml-auto bg-transparent border-none pointer" onClick={onClose}
          >
            <span className="sr-only">Close panel</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </button>
        </div>
          
        {children}
      </div>
    </div>
  )
}